import { render, staticRenderFns } from "./GoogleLoginButton.vue?vue&type=template&id=2c13359d&scoped=true&"
import script from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
export * from "./GoogleLoginButton.vue?vue&type=script&lang=js&"
import style0 from "./GoogleLoginButton.vue?vue&type=style&index=0&id=2c13359d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13359d",
  null
  
)

export default component.exports